import {
  FieldWrapper,
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { ExpressionType } from '@commenda/types/src/workflow/dsl/enums';
import { TExpr } from '@commenda/types/src/workflow/dsl/expression';

export const ExprEditor = ({
  value,
  onChange,
  showExpressionType = true,
}: {
  value: TExpr;
  onChange: (v: TExpr) => void;
  showExpressionType?: boolean;
}) => {
  return (
    <div className="flex flex-col gap-3">
      {showExpressionType && (
        <FieldWrapper>
          <Label>Expression Type</Label>
          <Select
            value={value.type}
            onValueChange={(t: ExpressionType) =>
              onChange({ type: t, src: value.src })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={ExpressionType.JSONATA}>JSONata</SelectItem>
            </SelectContent>
          </Select>
        </FieldWrapper>
      )}
      <FieldWrapper>
        <Label>Source</Label>
        <Input
          placeholder="e.g., account.transactions[$amount > 100].amount"
          value={value.src}
          onChange={(e) => onChange({ ...value, src: e.target.value })}
        />
      </FieldWrapper>
    </div>
  );
};
